import {Brick, registerBrick, Service} from 'olympe';
import {SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateAllRASharedMemory.brick';

/**
 * This brick fetches data related to CXML buyer cookies based on a given user ID.
 * It communicates with a shared memory service to retrieve the information.
 */
export default class GetFromCXMLTimeoutMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} buyerCookieId
     * @param {function()} forwardEvent
     * @param {function(string)} setBuyerCookie
     */
    update($, [buyerCookieId], [forwardEvent, setBuyerCookie]) {
        Service.get('allRaSharedMemory', {topic: SHARED_MEMORY_TOPICS.CXML_BUYER_COOKIE, buyerCookieId: buyerCookieId})
            .then((data) => {
                setBuyerCookie(data.buyerCookie);
                forwardEvent();
            });
    }
}

registerBrick('0197c1418e7e00bab500', GetFromCXMLTimeoutMap);
